/* eslint-disable
    prefer-const
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import CalendarUtil from 'calendar/CalendarUtil';
import {AlignmentSummary} from 'constants/AlignmentConstants';
import * as FileBrowserConstants from 'constants/FileBrowserConstants';
import * as FolderConstants from 'constants/FolderConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {RegistrySummary, TagSchema} from 'constants/RegistryConstants';
import {StorableSummary} from 'constants/SampleConstants';
import * as SourceConstants from 'constants/SourceConstants';
import {isSchemaTag, Tag} from 'folder-items/FileConstants';
import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ListingRendererType, ListingTypes} from 'nav/expanded/ListingRendererConstants';
import {EntrySummary} from 'notebook/ELNConstants';
import {getPartyDisplayString} from 'parties/GetPartyDisplayString';
import {getProcedureIcon} from 'procedures/design/procedureIconUtils';
import {FullFieldType} from 'schemas/fields/SchemaFieldConstants';
import * as TagUtil from 'schemas/tags/TagUtil';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {isTemplateCollectibleAlias} from 'ui-library/icons/IconAliases';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import APIUtil from 'util/APIUtil';
import * as DateUtil from 'util/DateUtil';
import fuzzydate from 'util/fuzzydate';

import {AnalysisSearchAttributesGraphQL} from '../../graphql-fragments/analysis-tool/__generated/AnalysisSearchAttributesGraphQL';
import {AnalyticsDashboardSearchAttributesGraphQL} from '../../graphql-fragments/insights/__generated/AnalyticsDashboardSearchAttributesGraphQL';

export interface TagType {
  type: FullFieldType | null;
  isComputed: boolean;
  isSnapshot?: boolean;
  isConvertedFromLink?: boolean;
}

export interface TagTypesByName {
  [tagName: string]: TagType;
}

export interface FileIconNameItem {
  id?: string;
  fileId?: string;
  tagSchema?: TagSchema | null;
  type?: string;
  sourceType?: string;
  parent?: FolderConstants.FolderSummary | null;
  procedureType?: ProcedureType | null;
}

export type ResultWithDate =
  | AlignmentSummary
  | AnalysisSearchAttributesGraphQL
  | AnalyticsDashboardSearchAttributesGraphQL
  | StorableSummary
  | EntrySummary
  | ListingTypes[ListingRendererType.FOLDER_ITEM];

function isBaseEntryTypeGuard(result: ResultWithDate): result is EntrySummary {
  return APIUtil.isEntry(result.id) || APIUtil.isStageEntry(result.id);
}

const FileBrowserUtil = {
  tagTypesByName(results: Array<{tags: Array<Tag>}>): TagTypesByName {
    // assumes results are all of the same schema
    const tagTypesByName: TagTypesByName = {};
    for (const result of results) {
      for (const tag of result.tags) {
        if (isSchemaTag(tag)) {
          tagTypesByName[tag.name] = {
            type: TagUtil.getFullFieldType(tag.tagSchemaField.fieldType),
            isComputed: tag.tagSchemaField.isComputed,
            isSnapshot: tag.tagSchemaField.isSnapshot,
            isConvertedFromLink: tag.tagSchemaField.isConvertedFromLink,
          };
        } else {
          tagTypesByName[tag.name] = {
            type: null,
            isComputed: false,
          };
        }
      }
    }
    return tagTypesByName;
  },
  propsToFolderPredicate(args: {
    showInventory: boolean;
    showNotebook: boolean;
  }): (folder: FolderConstants.MinimalFolder) => boolean {
    // If either type should be shown, we show all folder types on tenants with merged notebook and inventory
    // sections. But if neither should be shown, only root Project folders (type = ALL) should be shown so fall
    // through to the original logic below which will handle that.
    if (args.showInventory || args.showNotebook) {
      return () => true;
    }

    const typeBlocklist = _.compact([
      !args.showInventory ? FolderConstants.Type.INVENTORY : undefined,
      !args.showNotebook ? FolderConstants.Type.NOTEBOOK : undefined,
    ]);
    return (folder) => !typeBlocklist.includes(folder.type);
  },
  /**
   * Given a file, returns the correct icon name that can be used with BenchlingIcon.
   * Should maintain compatibility with search results (file-browser/search-result)
   * and workspace items (nav/workspace/WorkspaceTab)
   * @param  {Object} item
   * @param  {String} idKey  where the file api identifier can be found on `item`
   * @return {String}        icon name compatible with BenchlingIcon
   */
  getFileIconName(item: FileIconNameItem, idKey: 'id' | 'fileId' = 'id'): BenchlingIconName {
    // @ts-expect-error
    const modelType = APIUtil.apiIdToType(item[idKey]);
    const hasTagSchema = item.tagSchema != null;
    const isRNASequence = item.type === FileBrowserConstants.SEQUENCE_TYPE.SINGLE_STRANDED;
    const isOligo = item.type === FileBrowserConstants.SEQUENCE_TYPE.OLIGO;
    const isRegistry =
      modelType === ModelTypeConstants.SOURCE && item.sourceType === SourceConstants.REGISTRY_TYPE;
    const isFolder = modelType === ModelTypeConstants.FOLDER;
    const isRootFolder = isFolder && item.parent == null;
    const isMolecule = modelType === ModelTypeConstants.MOLECULE;
    if (isRegistry) {
      return ModelTypeConstants.REGISTRY;
    }
    if (isRootFolder) {
      return ModelTypeConstants.SOURCE;
    }
    if (hasTagSchema && !isTemplateCollectibleAlias(modelType)) {
      return item.tagSchema!.iconId;
    }
    if (isRNASequence) {
      return FolderItemIcon.RNASequence;
    }
    if (isOligo) {
      return FolderItemIcon.OligoV2;
    }
    if (isMolecule) {
      return FolderItemIcon.SmallMolecule;
    }
    if (modelType === ModelTypeConstants.REACTION) {
      return FolderItemIcon.Reaction;
    }
    if (modelType === ModelTypeConstants.PROCEDURE && item.procedureType != null) {
      return getProcedureIcon(item.procedureType);
    }
    return modelType as BenchlingIconName;
  },
  getResultDate(
    result: ResultWithDate,
    param: {fuzzy?: boolean; compact?: boolean; showTime?: boolean; forceModifiedAt?: boolean}
  ): {prefix: string; date: string} {
    if (param == null) {
      param = {};
    }
    let {fuzzy, compact, showTime, forceModifiedAt} = param;
    if (compact == null) {
      compact = false;
    }
    if (fuzzy == null) {
      fuzzy = false;
    }
    if (forceModifiedAt == null) {
      forceModifiedAt = false;
    }
    if (isBaseEntryTypeGuard(result) && !forceModifiedAt) {
      let startDate;
      let endDate;

      for (let i = 0; i < result.entryDays.length; i++) {
        if (result.entryDays[i].date !== '') {
          startDate = result.entryDays[i].date;
          break;
        }
      }

      for (let i = result.entryDays.length - 1; i > -1; i--) {
        if (result.entryDays[i].date !== '') {
          endDate = result.entryDays[i].date;
          break;
        }
      }
      // If no dates exist in the entry, fall back to Created at for the subtitle
      if (!startDate && !endDate) {
        let date = result.created_at;
        return {
          prefix: 'Created at ',
          date: fuzzy
            ? fuzzydate(date, {compact, showTime: showTime != null ? showTime : false})
            : DateUtil.readableTime(date, {showTime: showTime != null ? showTime : true}),
        };
      }
      // If `compact`, we only want to show the end date so we pass in `endDate` for both start and end
      startDate = compact ? endDate : startDate;
      return {
        prefix: '',
        date: CalendarUtil.readableDateRange(startDate, endDate, {showYear: !compact}),
      };
    }

    let date;
    // eslint-disable-next-line benchlint/no-in-operator
    if ('modified_at' in result && result.modified_at != null) {
      date = result.modified_at;
      // eslint-disable-next-line benchlint/no-in-operator
    } else if ('modifiedAt' in result && result.modifiedAt != null) {
      date = result.modifiedAt;
    }
    if (date == null) {
      return {prefix: '', date: ''};
    }
    return {
      prefix: 'Last modified ',
      date: fuzzy
        ? fuzzydate(date, {compact, showTime: showTime != null ? showTime : false})
        : DateUtil.readableTime(date, {showTime: showTime != null ? showTime : true}),
    };
  },
  getSourceNameAndOwnerComponent(source: RegistrySummary, faded: boolean = true): JSX.Element {
    return (
      <span>
        <span className={classNames({'u-faded': faded})}>{`${getPartyDisplayString(
          source.s_owner
        )} / `}</span>
        <span>{source.name}</span>
      </span>
    );
  },
  getRegistryName(registry: RegistrySummary): string {
    // All registries are named "Registry", so the name isn't very useful. Since organizations
    // only have one registry each, showing the org name is generally helpful.
    return registry.s_owner.name;
  },
};

export default FileBrowserUtil;
